// SnackbarServiceBridge.tsx
import { useEffect } from 'react';
import { useSnackbar } from './SnackbarContext';
import { snackbarService } from 'services/snackbarService';

export const SnackbarServiceBridge = () => {
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    snackbarService.register(showSnackbar);
  }, [showSnackbar]);

  return null;
};
